<div class="card-header">
  <app-breadcrumb [currentPage]="'overige transacties ' + reportName "></app-breadcrumb>
</div>
<div class="card-body" style="padding-top:100px;">
  <ng-container *ngIf="reportInfo">
    <app-other-transaction-list
      [year]="reportInfo.year"
      [clientId]="reportInfo.clientId"
      [reportType]="reportInfo.type"
      defaultPageSize="9999">
    </app-other-transaction-list>
    <button (click)="location.back()" class="btn arrow-left btn-left mt28">terug</button>
  </ng-container>
</div>
